import { jsx as u, jsxs as W } from "../../_virtual/jsx-runtime.mjs";
import * as l from "react";
import _ from "../../depend/rc-select/es/Select.mjs";
import "../../depend/rc-select/es/Option.mjs";
import "../../depend/rc-select/es/OptGroup.mjs";
import "../../depend/rc-select/es/BaseSelect.mjs";
import "../../depend/rc-select/assets/index.less.mjs";
import h from "../../depend/classnames/index.mjs";
import { icon as N, select as $, selectWrap as G, sizeMap as k, search as J, dropDown as Q, dropdownSizeMap as U, selectInPopup as X, dropdownOffset as Y, labelForSelect as Z, required as p } from "./css/ReoSelect.mjs";
import I from "../ReoIcon/ReoIcon.mjs";
import { useOmitProps as ee } from "../../hook/useOmitProps.mjs";
import { useSize as ne } from "../../hook/useSize.mjs";
import "../ReoForm/context/FormItemInputContext.mjs";
import "../ReoForm/context/ReoFormCompContext.mjs";
import { omitPropsKeys as le } from "./const.mjs";
import ae from "../ReoPopup/ReoPopupContext.mjs";
import { useTheme as te } from "../../hook/useTheme.mjs";
import { EThemeTemplate as ce } from "../../common/type.mjs";
const ie = l.forwardRef((e, L) => {
  const { includeByPopup: s } = l.useContext(ae), f = te({ theme: e.theme, template: ce.SELECT }), t = ne(e), V = ee(e, le), [C, O] = l.useState(), o = l.useMemo(() => {
    if (e.value !== "")
      return e.value ?? C;
  }, [e.value, C]), [w, g] = l.useState(e.searchValue ?? ""), r = l.useMemo(() => e.searchValue ?? w, [e.searchValue, w]), [d, S] = l.useState(!1), i = l.useCallback((n, a, c, m) => /* @__PURE__ */ u(
    I,
    {
      style: a,
      className: N,
      color: "var(--icon-color)",
      width: c ?? "var(--icon-width)",
      spin: m,
      name: n
    }
  ), []), M = l.useMemo(() => /* @__PURE__ */ u(
    I,
    {
      className: N,
      color: "var(--icon-color)",
      width: "var(--icon-width)",
      spin: !0,
      name: "icon-icon-loading-1"
    }
  ), []), T = l.useMemo(() => e.loading ? M : e.inputIcon !== void 0 ? e.inputIcon : d && !e.disabled && e.allowClear && (o !== void 0 && String(o).length || e.showSearch && r.length !== 0) ? null : i("icon-icon_arrow-down"), [
    d,
    i,
    r,
    o,
    M,
    e.allowClear,
    e.disabled,
    e.inputIcon,
    e.loading,
    e.showSearch
  ]), E = l.useMemo(() => e.loading || !d ? null : i("icon-cross2"), [d, i, e.loading]), x = l.useMemo(() => i(
    "icon-cross2",
    {},
    10
  ), [i]), y = l.useMemo(() => h(
    $,
    G,
    k[t],
    // props.showRequired ? css.required : null,
    e.showSearch ? J : null,
    e.className
  ), [e.className, e.showSearch, t]), F = l.useMemo(() => h(
    f,
    Q,
    U[t],
    s ? X : null,
    e.dropdownClassName
  ), [s, e.dropdownClassName, t, f]), v = l.useCallback((n) => e != null && e.encodeHTML ? e.encodeHTML(n) : n.replace(/</g, "&lt;").replace(/>/g, "&gt;"), [e]), H = l.useCallback((n, a) => {
    var c, m, b;
    if (O(n), e != null && e.shouldEscape && typeof n == "string") {
      const K = v(n);
      (c = e.onChange) == null || c.call(e, K, a);
    } else
      (m = e.onChange) == null || m.call(e, n, a);
    e.multiple && e.autoClearSearchValue !== !1 && (g(""), (b = e.onSearch) == null || b.call(e, ""));
  }, [v, e]), P = l.useCallback((n) => {
    var a;
    S(!0), (a = e.onMouseEnter) == null || a.call(e, n);
  }, [e]), R = l.useCallback((n) => {
    var a;
    S(!1), (a = e.onMouseLeave) == null || a.call(e, n);
  }, [e]), z = l.useCallback(() => {
    var n;
    (n = e.onClear) == null || n.call(e);
  }, [e]), A = l.useCallback((n, a) => {
    var c;
    return e.filterOption instanceof Function ? (c = e.filterOption) == null ? void 0 : c.call(e, n, a) : e.filterOption !== void 0 ? e.filterOption : String((a == null ? void 0 : a[e.searchByLabel === !1 ? "value" : "label"]) ?? "").toLowerCase().includes(n.toLowerCase());
  }, [e]), j = l.useMemo(() => e.dropdownAlign ?? {
    offset: Y[t]
  }, [e.dropdownAlign, t]), q = l.useMemo(() => e.label ? /* @__PURE__ */ u(
    "div",
    {
      className: Z,
      children: /* @__PURE__ */ u(
        "label",
        {
          htmlFor: e.id,
          children: e.label
        }
      )
    }
  ) : null, [e.id, e.label]), B = l.useCallback((n) => {
    var a;
    n.stopPropagation(), (a = e.onClick) == null || a.call(e, n);
  }, [e]), D = l.useCallback((n) => {
    var a;
    g(n), (a = e.onSearch) == null || a.call(e, n);
  }, [e]);
  return /* @__PURE__ */ W("div", { className: h(f, k[t]), children: [
    q,
    /* @__PURE__ */ u("div", { className: h({ [p]: e.showRequired }), children: /* @__PURE__ */ u(
      _,
      {
        mode: e.multiple ? "multiple" : void 0,
        ref: L,
        value: o,
        searchValue: r,
        animation: "slide-up",
        className: y,
        dropdownAlign: j,
        dropdownClassName: F,
        filterOption: A,
        virtual: !1,
        suffixIcon: T,
        allowClear: e.allowClear ? { clearIcon: E } : !1,
        removeIcon: x,
        notFoundContent: e.notFoundContent ?? "Not Data",
        listHeight: e.listHeight ?? 320,
        onClear: z,
        onChange: H,
        onMouseEnter: P,
        onMouseLeave: R,
        onClick: B,
        onSearch: D,
        ...V
      }
    ) })
  ] });
});
ie.displayName = "ReoSelect";
export {
  ie as default
};
//# sourceMappingURL=ReoSelect.mjs.map
